import labels from "utils/LocalizedStrings";
import sanitize from "utils/SanitizeHtml";
import { useLocation } from "react-router";
import { useState,useEffect } from "react";

const ImageSection = ({ guestUser }) => {
const location = useLocation();
const videoLibrary = location.pathname === "/video-library";
const dashboard = location.pathname === "/dashboard";
const [backgroundClass, setBackgroundClass] = useState("");
const isInvestor = !guestUser;

useEffect(() => {
  if (!isInvestor) {
    //NonInvestor
    setBackgroundClass(
      videoLibrary ? "insights-image" : "nonppt-image"
    );
    return;
  }
  // Investor
  setBackgroundClass(dashboard ? "" : "insights-image");
}, [isInvestor, videoLibrary, dashboard]);


  return (
    <section className={`imageSection ${backgroundClass} ` }>
      <div className="row ms-2 pt-5">
        <div className="col-9 col-md-5 text px-0">
          <div
            className={`h1 ${guestUser ? "fw-400" : "fw-bold"}`}
            dangerouslySetInnerHTML={sanitize(
              guestUser
                ? labels?.imageSection?.guestUserTitle
                : labels?.imageSection?.title
            )}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default ImageSection;
